// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10crL","question":"styles_question__1RK4G","description":"styles_description__FWRiy"};